import { render, staticRenderFns } from "./ReservationTwo.vue?vue&type=template&id=634fb2b0&scoped=true"
import script from "./ReservationTwo.vue?vue&type=script&lang=js"
export * from "./ReservationTwo.vue?vue&type=script&lang=js"
import style0 from "./ReservationTwo.vue?vue&type=style&index=0&id=634fb2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634fb2b0",
  null
  
)

export default component.exports